import { IExtendableDto } from "../../dto";
import { StationsBulkActionSourceEnum } from "../../models";
import {
  stationsBulkActionTargetAtom,
  stationsMapBulkPanelOpenAtom,
  stationsMapSelectedIdsAtom,
  tableRowsAtomFamily,
} from "../atoms";
import { boundedSelector } from "../selector-factories";
import { selectedTableRowsValues } from "./table-data.selectors";

/**
 * Station rows a bulk action should target. While the bulk-target panel is open and its radio
 * is "markers", this is the map-selected stations; otherwise it's the grid checkbox selection.
 * Kept out of the generic `selectedTableRowsValues` so that common selector stays entity-agnostic.
 */
export const stationsBulkTargetRowsSelector = boundedSelector<IExtendableDto[]>(
  {
    key: "stationsBulkTargetRowsSelector",
    get: ({ get }) => {
      const isMarkersTarget =
        get(stationsMapBulkPanelOpenAtom) &&
        get(stationsBulkActionTargetAtom).source ===
          StationsBulkActionSourceEnum.markers;

      if (!isMarkersTarget) {
        return get(selectedTableRowsValues("station"));
      }

      const tableRows = get(tableRowsAtomFamily("station")) ?? [];
      const markerIds = new Set(get(stationsMapSelectedIdsAtom));

      return tableRows.filter(({ id }) => markerIds.has(id));
    },
  },
);
